import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Service } from '../../../services';
import { GlobalService } from '../../../global.service';
import { LoadingScreenService } from '../../../services/loading-screen/loading-screen.service';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material';
import { AlertasComponent } from '../../../alertas/alertas.component';
import { Router } from '@angular/router';
import { Subscription } from "rxjs";
@Component({
  selector: 'app-carousel-datapurchase',
  templateUrl: './carousel-datapurchase.component.html',
  styleUrls: ['./carousel-datapurchase.component.sass']
})
export class CarouselDatapurchaseComponent implements OnInit {
  @Output() updatepayment = new EventEmitter<any>();
  @Output() updatescreenview = new EventEmitter<any>();
  @Input() offers:any;
  @Input() index;
  @Input() subscriber;
  @Output() updateInitializeData = new EventEmitter();
  public paymentData;
  public precio;
  public balanceAccount = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.billBalanceField;
  public banStatusField = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.banStatusField;
  public userName = atob(sessionStorage.getItem("userName2"));

  public token: string = sessionStorage.getItem("token");
  public billCycleField = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.billCycleField;
  public selectBan = atob(sessionStorage.getItem("selectBan"));
  paymentReceived: Subscription;
  constructor(private services: Service, private loadingScreenService: LoadingScreenService, private global: GlobalService, public dialog: MatDialog, private router: Router) { }

  ngOnInit() {
    this.paymentReceived = this.global.paymentReceived.subscribe((value: boolean) => {
      if (value == true && this.index==0) {
        this.loadingScreenService.stopLoading();
        const dialogConfig2 = new MatDialogConfig();
        dialogConfig2.disableClose = true;
        dialogConfig2.autoFocus = true;
        dialogConfig2.data = { message: "Se ha agregado el Paquete Adicional de Data" };
        const dialogRef2 = this.dialog.open(AlertasComponent, dialogConfig2);
        dialogRef2.afterClosed().subscribe(value2 => {
          if (value2 == "continue") {
            this.updateInitializeData.emit();
          }
        });
      }
    });
  }
  addOffers(OfferId, paquete, price2, groupID, subscriberNumber) {
    if (this.global.validateSession() == true) {
      if (this.banStatusField === 'S' || this.banStatusField === 's') {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.data = { message: 'Su cuenta ' + this.selectBan + ' esta suspendida. Para activar la misma, favor realice su pago.', btmConfirm: true, labelSi: 'Pagar', labelNo: 'Cancelar' };
        const dialogRef = this.dialog.open(AlertasComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(value => {
          if (value == 'continue') {
            //ir al pago
          }
        });
      }
      else {
        this.loadingScreenService.startLoading();
        let price = String(price2).split("$")[1];
        //Valida paquete en espera de uso
        this.services.getReadSubscriber(subscriberNumber).subscribe(data => {
          var sw = 0;
          for (var i = 0; i < data.Offers.length; i++) {
            if (data.Offers[i].OfferGroupOrder === "1") {
              //oferta base
            }
            else {
              if (data.Offers[i].Balances[0].BalanceAmount === 0 && (/ROAM/.test(data.Offers[i].OfferGroup)) === false) {
                this.loadingScreenService.stopLoading();
                //ojo quitar comentario valida los paquetes existentes
                sw = 1;
                this.global.notif('Ya cuentas con un paquete de data adicional en espera de uso.');
                return false;
              }
            }
          }
          if (sw === 0) {
            this.validateCreditLimit(this.selectBan, price, paquete, groupID, subscriberNumber, OfferId);
          }
        });
      }
    }
  }


  validateCreditLimit(ban, price, paquete, groupID, subscriberNumber, OfferId) {
    let typeMessage='dataPackage';
    let balanceAccount = parseFloat(String(this.balanceAccount).replace(',', '')).toFixed(2);
    if (OfferId == "DIARIO10") {
      this.loadingScreenService.stopLoading();
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      dialogConfig.autoFocus = true;
      dialogConfig.data = { message: 'Estimado Cliente: El paquete seleccionado será agregado con cargo a su próxima factura. ¿Está seguro de agregar el paquete: ' + paquete + ' ?', btmConfirm: true, labelSi: 'Si', labelNo: 'No' };
      const dialogRef = this.dialog.open(AlertasComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(value => {
        if (value == 'continue') {
          this.addOffersToSubscriberDIARIO10(this.token,
            this.subscriber.planInfoField.sOCInfoField,
            OfferId,
            this.subscriber.productTypeField,
            subscriberNumber,
            this.selectBan,
            this.subscriber.planInfoField.commitmentStartDateField,
            this.subscriber.planInfoField.commitmentEndDateField,
            this.subscriber.planInfoField.effectiveDateField,
            this.subscriber.planInfoField.socRateField);
        }
      });
    }
    else {
      this.services.validateCreditLimit(ban, balanceAccount, price).subscribe(data => {
        if (data.HasError == false) {
          let availableCredit = String(data.AvailableCredit);
          let balanceAccount = this.balanceAccount.replace(",", "");
          if (this.balanceAccount.search("CR") > -1) {
            balanceAccount = 0;
          }
          let remaining = parseFloat(availableCredit) - parseFloat(price);
          if (remaining > 0) {
            this.aprovisionar(paquete, groupID, subscriberNumber, OfferId, price);
          }
          else {
            this.loadingScreenService.stopLoading();
            const dialogConfig = new MatDialogConfig();
            dialogConfig.disableClose = true;
            dialogConfig.autoFocus = true;
            dialogConfig.data = { message: 'Estimado cliente el paquete de data adicional seleccionado no califica para cargo en factura, por favor seleccione un plan de menor costo o continúe su compra efectuando el pago inmediato usando su tarjeta de crédito.', btmConfirm: true, labelSi: 'Pagar', labelNo: 'Cancelar' };
            const dialogRef = this.dialog.open(AlertasComponent, dialogConfig);
            dialogRef.afterClosed().subscribe(value => {
              if (value == 'continue') {
                this.global.newPaymentNoLimit(3,typeMessage, this.selectBan, subscriberNumber, price, atob(sessionStorage.getItem("email")), sessionStorage.getItem("name"),OfferId, this.token);
                //  this.goToPayment(subscriberNumber,groupID,OfferId,this.billCycleField,paquete,price);
              }
            });
          }
        }
        else {
          this.loadingScreenService.stopLoading();
          this.global.notif(data.ErrorDesc);
        }
      });
    }

  }
  goToPayment(subscriberNumberPay, groupIDPay, OfferIdPay, billCycleFieldPay, equipmenttoPay, amountPayable) {
    let price: any;
    price = amountPayable;
    let datasend = '{"data":{"module":"datapurchase","params":{"subscriberNumberPay":"' + subscriberNumberPay + '","groupIDPay":"' + groupIDPay + '","OfferIdPay":"' + OfferIdPay + '","billCycleFieldPay":"' + billCycleFieldPay + '"},"labels":[{"label":"producto","text":"' + equipmenttoPay + '"},{"label":"monto","text":"' + '$' + amountPayable + '"}],"confirmText":" su paquete se ha agregado exitosamente y esta disponible para su consumo","mount":"' + price + '","product":"' + equipmenttoPay + '"}}';
    this.paymentData = JSON.parse(datasend);

    this.updatepayment.emit(this.paymentData);
    this.updatescreenview.emit(1);
  }
  aprovisionar(paquete, groupID, subscriberNumber, OfferId, price) {
    this.loadingScreenService.stopLoading();
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = { message: 'Estimado Cliente: El paquete seleccionado será agregado con cargo a su próxima factura. ¿Está seguro de agregar el paquete: ' + paquete + ' ?', btmConfirm: true, labelSi: 'Si', labelNo: 'No' };
    const dialogRef = this.dialog.open(AlertasComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(value => {
      if (value == 'continue') {

        if (OfferId == "DIARIO10") {
          this.addOffersToSubscriberDIARIO10(this.token,
            this.subscriber.planInfoField.sOCInfoField,
            OfferId,
            this.subscriber.productTypeField,
            subscriberNumber,
            this.selectBan,
            this.subscriber.planInfoField.commitmentStartDateField,
            this.subscriber.planInfoField.commitmentEndDateField,
            this.subscriber.planInfoField.effectiveDateField,
            this.subscriber.planInfoField.socRateField);
        }
        else if (groupID === "" || groupID === undefined || groupID === null) {
          this.addOffersToSubscriber(subscriberNumber, this.billCycleField, OfferId, "", "1", this.token, this.userName, "", "home");
        }
        else {
          this.addOffersToGroup(subscriberNumber, this.billCycleField, OfferId, groupID, "", "1", this.token, this.userName, "", "home");
        }
      }
    });
  }
  addOffersToSubscriberDIARIO10(token, sOCInfoField, OfferId, productTypeField, subscriber, selectBan, commitmentStartDateField, commitmentEndDateField, effectiveDateField, socRateField) {
    this.loadingScreenService.startLoading();
    let ini = "";
    if (commitmentStartDateField != "" && commitmentStartDateField != null && commitmentStartDateField != "0") {
      ini = commitmentStartDateField.split("/");
      commitmentStartDateField = ini[2] + "-" + ini[1] + "-" + ini[0];
    }
    else {
      commitmentStartDateField = "";
    }
    if (commitmentEndDateField != "" && commitmentEndDateField != null && commitmentEndDateField != "0") {
      ini = commitmentEndDateField.split("/");
      commitmentEndDateField = ini[2] + "-" + ini[1] + "-" + ini[0];
    }
    else {
      commitmentEndDateField = "";
    }
    if (effectiveDateField != "" && effectiveDateField != null && effectiveDateField != "0") {
      ini = effectiveDateField.split("/");
      effectiveDateField = ini[2] + "-" + ini[1] + "-" + ini[0];
    }
    else {
      effectiveDateField = "";
    }

    this.services.addOffersToSubscriberDIARIO10(token, btoa(sOCInfoField), btoa(OfferId), btoa(productTypeField), btoa(subscriber), btoa(selectBan), btoa(commitmentStartDateField), btoa(commitmentEndDateField), btoa(effectiveDateField), btoa(sOCInfoField)).subscribe(data => {
      if (data.hasError == false) {
        this.loadingScreenService.stopLoading();
        const dialogConfig2 = new MatDialogConfig();
        dialogConfig2.disableClose = true;
        dialogConfig2.autoFocus = true;
        dialogConfig2.data = { message: "Se ha agregado el Paquete Adicional de Data" };
        const dialogRef2 = this.dialog.open(AlertasComponent, dialogConfig2);
        dialogRef2.afterClosed().subscribe(value2 => {
          if (value2 == "continue") {
            this.updateInitializeData.emit();
          }
        });
      }
      else {
        this.loadingScreenService.stopLoading();
        this.global.notif(data.ErrorDesc);
      }
    });
  }
  addOffersToSubscriber(SubscriberId, Cicle, OfferId, paymentID, Charge, token, userName, tipo, url2) {
    this.loadingScreenService.startLoading();
    this.services.addOffersToSubscriber(SubscriberId, Cicle, OfferId, paymentID, Charge, this.token, this.userName).subscribe(data => {
      if (data.HasError == false) {
        if (data.ResultCode == 0 || data.ResultCode == "0") {
          this.loadingScreenService.stopLoading();
          const dialogConfig2 = new MatDialogConfig();
          dialogConfig2.disableClose = true;
          dialogConfig2.autoFocus = true;
          dialogConfig2.data = { message: "Se ha agregado el Paquete Adicional de Data" };
          const dialogRef2 = this.dialog.open(AlertasComponent, dialogConfig2);
          dialogRef2.afterClosed().subscribe(value2 => {
            if (value2 == "continue") {
              this.updateInitializeData.emit();
            }
          });
        }
        else {
          this.loadingScreenService.stopLoading();
          this.global.notif('Estimado Cliente, ha ocurrido un error en el aprovisionamiento del paquete de datos. ' + data.Description);
        }
      }
      else {
        this.loadingScreenService.stopLoading();
        this.global.notif(data.Description);
      }
    });
  }
  addOffersToGroup(SubscriberId, Cicle, OfferId, GroupId, paymentID, Charge, token, userName, tipo, url2) {
    this.loadingScreenService.startLoading();
    this.services.addOffersToGroup(SubscriberId, Cicle, OfferId, GroupId, paymentID, Charge, token, userName).subscribe(data => {
      if (data.HasError === false) {
        if (data.ResultCode == 0 || data.ResultCode == "0") {
          this.loadingScreenService.stopLoading();
          const dialogConfig2 = new MatDialogConfig();
          dialogConfig2.disableClose = true;
          dialogConfig2.autoFocus = true;
          dialogConfig2.data = { message: "Se ha agregado el Paquete Adicional de Data" };
          const dialogRef2 = this.dialog.open(AlertasComponent, dialogConfig2);
          dialogRef2.afterClosed().subscribe(value2 => {
            if (value2 == "continue") {
              this.updateInitializeData.emit();
            }
          });
        }
        else {
          this.loadingScreenService.stopLoading();
          this.global.notif('Estimado Cliente, ha ocurrido un error en el aprovisionamiento del paquete de datos. ' + data.Description);
        }
      }
      else {
        this.loadingScreenService.stopLoading();
        this.global.notif(data.Description);
      }
    });
  }
}
